export enum EHeatmapType {
  Click = 'click',
  Scroll = 'scroll',
}
